import React, { useMemo } from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { connect } from "react-redux";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import Algemeen from "./Tabs/Algemeen";

import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";

function VoucherForm(props) {
  const endPoint = useMemo(() => {
    return "core/vouchers";
  }, []);

  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });
  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"vouchers"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.title);
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{}}
            extraFields={extraFields}
            extraFormProps={{
              vestiging,
              vestigingId: vestiging?.id ?? props.vestiging_id,
              menukaartVestigingId,
            }}
            mode={"onSubmit"}
            objectsExcludedAsRelation={{}}
            onGetModel={onGetModel}
            pageTitle={getTranslation("vouchers.form.pageTitle", "Vouchers")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{}}
            parseOutput={{}}
            parseOutput2={{}}
            revalidateMode={"onChange"}
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tDefault={"General"} tKey={"vouchers.form.tabs.algemeen"} />,
                tabContent: <Algemeen />,
              },
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(VoucherForm);
